import LogManager from './log-manager'
import { uniqueString } from '../utils/string'

const _batchListener = uniqueString('LogProvider_batchListener')

export default class LogProvider {
  constructor(config = {}) {
    if (typeof this.constructor.is !== 'string') {
      throw new Error('LogProvider -> static property `is` required')
    }

    this.debugMode = config.debug || false

    this[_batchListener] = null
  }

  log(data, priority) {
    LogManager.instance.log(data, priority, this)
  }

  onBatch() {
    /* override */
  }

  addBatchListener() {
    if (this[_batchListener]) return

    this[_batchListener] = (batch, meta = {}) => {
      if (batch.contains(this)) {
        const logs = batch.get(this)

        this.printBatch(logs)
        this.onBatch(logs, meta)
      }
    }

    LogManager.instance.on('batch', this[_batchListener])
  }

  removeBatchListener() {
    if (!this[_batchListener]) return

    LogManager.instance.off('batch', this[_batchListener])
  }

  printBatch(batch) {
    if (this.debugMode) {
      console.log(`BATCH : ${this.constructor.is} -> ${batch.length} logs`, batch)
    }
  }
}
